import { isAndroid, isFirefox } from '@core/userAgent';
import { Wrapper } from './Wrapper';
/**
 *
 */
export class VideoElementWrapper extends Wrapper {
    /**
     *
     */
    constructor(type, video, videoEl, preferredCDNs) {
        super(type, video);
        this.preferredCDNs = [];
        this.videoEl = videoEl;
        this.preferredCDNs = preferredCDNs ?? [];
        // Transparent gif poster is needed for some android web views which
        // display enlarged play icon instead. On other platforms it's not needed
        // and will cause the video to not display the first frame.
        if (isAndroid) {
            this.videoEl.poster =
                'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
        }
        // Disable floating picture-in-picture button in Firefox.
        // Note: Firefox users can still use right-click menu to enter picture-in-picture mode.
        if (isFirefox) {
            this.videoEl.disablePictureInPicture = true;
        }
    }
    /**
     * Support for subtitles HTMLTrackElement[] attached to <video> element.
     * @param subtitles
     */
    setSubtitles(subtitles) {
        this.videoEl
            .querySelectorAll('track[kind="captions"],track[kind="metadata"],track[kind="subtitles"]')
            .forEach((track) => track.remove());
        // Setting `crossOrigin` to `anonymous` so browser lets
        // us load VTTs from the CDN
        this.crossOrigin = 'anonymous';
        const tracks = [];
        subtitles.forEach(({ src, srclang }) => {
            const track = document.createElement('track');
            track.src = src;
            track.srclang = srclang;
            // Setting `kind` to `metadata` so browsers won't
            // try to show the captions themselves
            track.kind = 'metadata';
            track.style.display = 'none';
            // Adding condition because createElement under Jest
            // wont create `track.track` property
            if (track.track) {
                track.track.mode = 'hidden';
            }
            // for later when we support multiple langs
            // const isBrowserLang = navigator.language.indexOf(sub.language) === 0
            track.default = true;
            this.videoEl.appendChild(track);
            tracks.push(track);
        });
        return tracks;
    }
    /**
     *
     */
    get duration() {
        return this.videoEl.duration;
    }
    /**
     *
     */
    get className() {
        return this.videoEl.className;
    }
    /**
     *
     */
    set className(value) {
        this.videoEl.className = value;
    }
    /**
     *
     */
    get crossOrigin() {
        return this.videoEl.crossOrigin;
    }
    /**
     *
     */
    set crossOrigin(value) {
        this.videoEl.crossOrigin = value;
    }
    /**
     *
     */
    get currentTime() {
        return this.videoEl.currentTime;
    }
    /**
     *
     */
    set currentTime(value) {
        this.videoEl.currentTime = value;
    }
    /**
     *
     */
    get loop() {
        return this.videoEl.loop;
    }
    /**
     *
     */
    set loop(value) {
        this.videoEl.loop = value;
    }
    /**
     *
     */
    get muted() {
        return this.videoEl.muted;
    }
    /**
     *
     */
    set muted(value) {
        this.videoEl.muted = value;
    }
    /**
     *
     */
    get volume() {
        return this.videoEl.volume;
    }
    /**
     *
     */
    set volume(value) {
        this.videoEl.volume = value;
    }
    /**
     *
     */
    get playsInline() {
        return this.videoEl.playsInline;
    }
    /**
     *
     */
    set playsInline(value) {
        this.videoEl.playsInline = value;
    }
    /**
     *
     */
    get poster() {
        return this.videoEl.poster;
    }
    /**
     *
     */
    set poster(value) {
        this.videoEl.poster = value;
    }
    /**
     *
     */
    get preload() {
        return this.videoEl.preload;
    }
    /**
     *
     */
    set preload(value) {
        this.videoEl.preload = value;
    }
    /**
     *
     */
    set tabIndex(value) {
        this.videoEl.tabIndex = value;
    }
    /**
     *
     */
    get seeking() {
        return this.videoEl.seeking;
    }
    /**
     *
     */
    get autoplay() {
        return this.videoEl.autoplay;
    }
    /**
     *
     */
    set autoplay(value) {
        this.videoEl.autoplay = value;
    }
    /**
     *
     */
    get ended() {
        return this.videoEl.ended;
    }
    /**
     *
     */
    get readyState() {
        return this.videoEl.readyState;
    }
    /**
     *
     */
    get src() {
        return this.videoEl.src;
    }
    /**
     *
     */
    set src(value) {
        this.videoEl.src = value;
    }
    /**
     *
     */
    get paused() {
        return this.videoEl.paused;
    }
    /**
     *
     */
    get width() {
        return this.videoEl.width || this.videoEl.offsetWidth;
    }
    /**
     *
     */
    get height() {
        return this.videoEl.height || this.videoEl.offsetHeight;
    }
    /**
     *
     */
    get textTracks() {
        return this.videoEl.textTracks;
    }
    /**
     *
     */
    get latency() {
        return 0;
    }
    /**
     *
     */
    get elapsedTime() {
        return this.currentTime;
    }
    /**
     *
     */
    set onCanPlay(value) {
        this.videoEl.oncanplay = value;
    }
    /**
     *
     */
    set onClick(value) {
        this.videoEl.onclick = value;
    }
    /**
     *
     */
    set onLoadStart(value) {
        this.videoEl.onloadstart = value;
    }
    /**
     *
     */
    load() {
        this.videoEl.load();
    }
    /**
     *
     */
    play() {
        return this.videoEl.play();
    }
    /**
     *
     */
    pause() {
        return this.videoEl.pause();
    }
    /**
     *
     */
    dispatchEvent(event) {
        return this.videoEl.dispatchEvent(event);
    }
    /**
     *
     */
    addEventListener(type, listener, options) {
        this.videoEl.addEventListener(type, listener, options);
    }
    /**
     *
     */
    removeEventListener(type, listener, options) {
        this.videoEl.removeEventListener(type, listener, options);
    }
    /**
     *
     */
    getContainer() {
        return this.videoEl;
    }
    /**
     *
     */
    reset(_cacheKey, _video) { }
}
